import type { ElementType, ReactNode } from 'react';

import { cn } from '@/shared/lib/cn';

import styles from './Ceremony.module.css';

export type CeremonyTone = 'gold' | 'teal' | 'neutral';

export interface CeremonyProps {
  as?: ElementType;
  tone?: CeremonyTone;
  className?: string;
  children?: ReactNode;
}

/**
 * Церемониальная подпись из референса: «FIELD AWAKENING», «SYSTEM ONLINE».
 * Широко разреженный uppercase, тонкий вес, лёгкий bloom.
 */
export function Ceremony({
  as,
  tone = 'neutral',
  className,
  children,
}: CeremonyProps): React.ReactElement {
  const Component = (as ?? 'p') as ElementType;
  return (
    <Component className={cn(styles.ceremony, styles[tone], className)}>{children}</Component>
  );
}
